import { PrimaryText, UserAccountContainer, ContentWrapper, TextContainer } from './UserAccountSection.styles';
import { SecondaryText } from '../../../CustomList/CustomList.styles';
import { StyledAvatar } from '../../../StyledAvatar/StyledAvatar';
const UserAccountSection = ({ user, futureShiftCount, onClick }) => {
  return (
    <UserAccountContainer onClick={onClick}>
      <ContentWrapper>
        <StyledAvatar
          size="medium"
          alt={user?.employeeInfo?.displayName || 'User'}
          src={user?.employeeInfo?.profileImageUrl}
        />
        <TextContainer>
          <PrimaryText variant="bodyRegular">My Account</PrimaryText>
          <SecondaryText variant="footNoteRegular">
            {futureShiftCount === 0 ? 'No' : futureShiftCount} shift{futureShiftCount === 1 ? '' : 's'} scheduled
          </SecondaryText>
        </TextContainer>
      </ContentWrapper>
    </UserAccountContainer>
  );
};

export default UserAccountSection;
